import * as React from 'react';
import * as $ from 'jquery';

import { IGlob } from '../../../../pdc-platform/src/ts/Glob';
import { IPopupOptions } from '../../../../pdc-platform/src/ts/actions/DialogActions';

const reactGlobalClick = require('../../../../_common/platform/ts/reactGlobalClick');

export interface IHelpPopupOptions extends IPopupOptions {
    TOC: string;
    Document: string;
    title: string;
    popupPriority?: number;
    showArrow?: boolean;
}

export interface IHelpPopupProps {
    options: IHelpPopupOptions;
    zIndex: number;
    glob: IGlob;
    close(): void;
}

interface IHelpPopupState {
    dialogHeight: number;
    resized: boolean;
    containerSize: number;
}

export class HelpPopupBox extends React.Component<IHelpPopupProps, IHelpPopupState> {
    static top: number = 0;
    static left: number = 0;

    private globalClickIndex = 0;
    private references: {
        popoverArrow?: HTMLDivElement;
        popoverHeader?: HTMLHeadingElement;
        popoverContent?: HTMLDivElement;
        popoverBody?: HTMLDivElement;
        toc?: HTMLDivElement;
        doc?: HTMLDivElement;
    } = {};

    constructor(props) {
        super(props);

        this.state = {
            dialogHeight: 0,
            resized: false,
            containerSize: 0
        };
    }

    containerClick = (e) => {
        e.stopPropagation();
        e.preventDefault();
    };

    startResize = () => {
        this.setState({
            resized: true
        });

        this.processContainerResize();
    };

    processContainerResize = () => {
        const dialog = this.references.popoverContent;
        const dialogHeight = dialog?.offsetHeight || 0;

        this.setState({
            containerSize: dialogHeight
        });
    };

    setContainerSize = () => {
        if (this.state.resized === true) {
            return;
        }

        const dialog = this.references.popoverContent;
        const dialogHeight = dialog?.offsetHeight || 0;

        this.setState({
            containerSize: dialogHeight
        });
    };

    componentDidMount() {
        var self = this;
        const tocElement = this.references.toc;
        const docElement = this.references.doc;

        $('a', tocElement).click((e: any) => {
            if ($(e.target.hash) && $(e.target.hash).length > 0) {
                $(docElement).scrollTop($(e.target.hash)[0].offsetTop);
            }
        });

        if (this.props.options.popupPriority != null) {
            this.globalClickIndex = reactGlobalClick.register(this.props.close, this.props.options.popupPriority);
        } else {
            this.globalClickIndex = reactGlobalClick.register(this.props.close, 0);
        }

        const dialog = this.references.popoverContent;
        const dialogHeight = dialog?.offsetHeight;

        this.setState({ dialogHeight: dialogHeight });

        $(dialog).draggable({
            handle: '.popover-header',
            stop: this.handleDragStop,
            containment: 'document'
        });

        $(window).on('resize', this.setContainerSize);

        $(document).on('mousedown.pdcHelpTools', (e) => {
            var clicked = $(e.target); // get the element clicked
            let resizeables = document.getElementsByClassName('ui-resizable-handle');
            let resizableClicked = false;

            for (let index = 0; index < resizeables.length; index++) {
                const resizeable = resizeables[index];

                if (clicked.is(resizeable)) {
                    resizableClicked = true;
                    break;
                }
            }

            if (
                clicked.is(self.references.popoverBody) ||
                clicked.parents().is(self.references.popoverBody) ||
                clicked.is(self.references.popoverHeader) ||
                clicked.is(self.references.popoverArrow) ||
                resizableClicked
            ) {
                return; // click happened within the dialog, do nothing here
            } else {
                // click was outside the dialog, so close it
                self.props.close();
            }
        });
    }

    componentWillUnmount() {
        $(document).off('mousedown.pdcHelpTools');

        const dialog = this.references.popoverContent;

        $(dialog).draggable('destroy');
        $(dialog).resizable('destroy');
        reactGlobalClick.unregister(this.globalClickIndex);
        delete this.globalClickIndex;
    }

    handleDragStop = (e, ui) => {
        const dialog = this.references.popoverContent;

        HelpPopupBox.top = dialog.offsetTop;
        HelpPopupBox.left = dialog.offsetLeft;
    };

    render() {
        const { options } = this.props;
        const { containerSize } = this.state;
        const viewPort = document.documentElement.clientHeight;
        const width = 600;
        const iconWidth = 32;
        const offsetLeft = iconWidth / 2 - 2;
        const offsetTop = 6;

        let arrowStyle = { top: '5px' };
        let left = HelpPopupBox.left;
        let top = HelpPopupBox.top;
        let popoverClass = ' left';

        if (options.left > 0) {
            if (options.left - width - offsetLeft > 0) {
                left = options.left - width - offsetLeft;
            } else {
                popoverClass = ' right';
                left = options.left + iconWidth - 2;
            }

            top = options.top - offsetTop;
        }

        const dialogHeight = containerSize > this.state.dialogHeight ? containerSize : this.state.dialogHeight;
        const header = this.references.popoverHeader?.offsetHeight || 0;
        const popoverBody = this.references.popoverBody;
        const paddingTop = parseInt($(popoverBody)?.css('paddingTop')) || 0;
        const paddingBottom = parseInt($(popoverBody)?.css('paddingBottom')) || 0;
        const maxHeight = (dialogHeight > 600 ? dialogHeight : 600) - header - paddingTop - paddingBottom;
        const dialog = this.references.popoverContent;

        $(dialog).resizable({
            start: this.startResize,
            resize: this.processContainerResize,
            minHeight: this.state.dialogHeight
        });

        if (top + dialogHeight > viewPort) {
            const diff = top + dialogHeight - viewPort - 5;

            top = top - diff;
            arrowStyle = { top: diff + 5 + 'px' };
        }

        let tocElement: React.JSX.Element;

        if (options.TOC != null) {
            tocElement = (
                <div
                    className="col-4"
                    ref={(input) => {
                        this.references.toc = input;
                    }}
                    dangerouslySetInnerHTML={{ __html: options.TOC }}
                ></div>
            );
        }

        let arrowDiv: React.JSX.Element;

        if (options.showArrow) {
            arrowDiv = (
                <div
                    style={arrowStyle}
                    className="arrow"
                    ref={(input) => {
                        this.references.popoverArrow = input;
                    }}
                ></div>
            );
        }

        return (
            <div
                className={'popover ui-draggable ' + popoverClass}
                ref={(input) => {
                    this.references.popoverContent = input;
                }}
                style={{
                    display: 'block',
                    position: 'absolute',
                    left: left,
                    top: top,
                    zIndex: this.props.zIndex,
                    minWidth: width + 'px',
                    maxWidth: screen.width + 'px' //EVG: To override max-width in Bootstrap.
                }}
                onClick={this.containerClick}
                onBlur={this.props.close}
            >
                {arrowDiv}
                <h3
                    className="popover-header"
                    ref={(input) => {
                        this.references.popoverHeader = input;
                    }}
                >
                    {options.title}
                    <button type="button" className="close" onClick={this.props.close}>
                        ×
                    </button>
                </h3>
                <div
                    className="popover-body"
                    ref={(input) => {
                        this.references.popoverBody = input;
                    }}
                >
                    <div className="row">
                        {tocElement}

                        <div
                            className={options.TOC != null ? 'col-8' : 'col'}
                            ref={(input) => {
                                this.references.doc = input;
                            }}
                            dangerouslySetInnerHTML={{
                                __html: options.Document
                            }}
                            style={{ maxHeight: maxHeight + 'px', overflow: 'auto' }}
                        ></div>
                    </div>
                </div>
            </div>
        );
    }
}
